export enum MessageReadStatus {
  Unread = 'Unread',
  Read = 'Read'
}

export interface IBuildCommunication {
  lotNumber: number;
  jobId: number;
  displayName: string;
  buildId: number;
  hasUnreadMessage: boolean;
}

export interface IBuildCommunicationQueryParams {
  neighborhoodId?: number | string;
  lotNumber?: number | string;
  restrictToOpenBuilds?: boolean;
  restrictToBuildsWithUnread?: boolean;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
}

export interface IBuildPhotoFile {
  buildCommunicationPhotoFileId: number;
  photoUrl: string;
  originalFileName: string;
  contentType: string | null;
  fileSize: number;
  createdAt: string;
  createdBy: string;
}

export interface IBuildPhoto {
  buildCommunicationPhotosId: number;
  comment: string;
  createdAt: string;
  createdBy: string;
  photoFiles: IBuildPhotoFile[];
}

export interface IBuildCommunicationInfo {
  headerInfo: string;
}

export interface IBuildMessage {
  buildCommunicationMessagesId: number;
  buildTeamMessageReadStatus: MessageReadStatus;
  message: string;
  createdAt: string;
  createdBy: string;
  fileUrl: string;
  createdByFullName: string;
  fileType: 'PDF' | 'Image' | 'Video' | 'None';
}

export interface IBuildMessageQueryParams {
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number;
}

export interface IBuildMessageFormData {
  Image?: File;
  Message: string;
}

export interface IBuildPhotoFormData {
  Images: File[];
  Comment: string;
}
